export default __webpack_public_path__ + "static/media/no_logo-icon.95758018.svg";